<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <div>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>

<style>
.bodyy {
  background: #F7F8FA;
  padding: 0.3rem 0;
}

.index-dropdown-menu .van-dropdown-menu__bar {
  height: 40px;
  background: none;
  box-shadow: none;
}

.index-dropdown-menu .van-dropdown-menu__title {
  padding-top: 0.5rem;
}

.van-dropdown-menu__bar {
  background: #F5F8FB;
}

.van-field__control {
  color: blue;
}

.van-field--disabled .van-field__label {
  color: #252323;
}

.van-dialog__message {
  font-size: 18px;
}
</style>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html, body {
  width: 100%;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

.page-title {
  height: 2.6rem;
  position: fixed;
  z-index: 9;
  top: 0;
  width: 100%;
  text-align: center;
  border-bottom: 0.1rem solid #dad7d7;
  line-height: 2.6rem;
  font-size: 20px;
  color: #000000;
  background: #FFFFFF;
}
</style>
